window.EBContext = {modules: {}, utils: {}, options: {}, session: {}, loadedRequires: {}, ...window.EBContext};

EBContext.modules.Async = function(){
	this.eventsObj = {};
	var self = this;
	this.debug=false;
	this.getEventObj = function(eventName){
		if(!eventName) eventName = 'general';
		self.eventsObj[eventName] = self.eventsObj[eventName] || {name: eventName, calls: {}, waiting: 0, event: new Event('EBContext.async.' + eventName)};
		return self.eventsObj[eventName];
	};
	this.start = function(id, eventName){
		var eventObj = self.getEventObj(eventName);
		if(!Array.isArray(id)) id = [id];
		var wait = 0;
		for(var i in id){
			eventObj.calls[id[i]] = eventObj.calls[id[i]] || {waiting: 0, finished: 0};
			eventObj.calls[id[i]].waiting++;
			wait+=eventObj.calls[id[i]].waiting;
		}
		eventObj.waiting = wait;
		if(self.debug) self.log(eventName);
	};
	this.finish = function(id, eventName){
		var eventObj = self.getEventObj(eventName);
		if(!Array.isArray(id)) id = [id];
		var wait = 0, i;
		for(i in id){
			eventObj.calls[id[i]] = eventObj.calls[id[i]] || {waiting: 0, finished: 0};
			if(eventObj.calls[id[i]].waiting > 0){
				eventObj.calls[id[i]].waiting--;
				eventObj.calls[id[i]].finished++;
			}
		}
		for(i in eventObj.calls){
			wait+=eventObj.calls[i].waiting;
		}
		eventObj.waiting = wait;
		if(wait === 0) document.dispatchEvent(eventObj.event);
		if(self.debug) self.log(eventName);
	};
	this.register = function(callback, eventName){
		var eventObj = self.getEventObj(eventName);
		if(eventObj.waiting === 0){
			try {
				callback();
			} catch (e) {
				console.error(e);
			}
		} else {
			document.addEventListener('EBContext.async.' + eventObj.name, function(){ 
				try { 
					callback();
				} catch (e) { 
					console.error(e);
				}
			});
		}
	};
	this.log = function(eventName){
		eventName = eventName || 'general';
		
		var eventObj = self.getEventObj();
		var callsKeys = Object.keys(eventObj.calls);
		var loading = [];
		
		for(i=0;i<callsKeys.length;i++){
			if(eventObj.calls[callsKeys[i]].waiting > 0) loading.push(callsKeys[i]);
		}
		
		if(loading.length > 0){
			console.groupCollapsed('Waiting for ' + loading.length + ' JS modules in event "EBContext.async.' + eventName + '"!');
			for(i=0;i<loading.length;i++){
				console.log(loading[i]);
			}
			console.groupEnd();
		}
		else if(callsKeys.length > 0){
			console.log('All JS modules for event "EBContext.async.' + eventName + '" were loaded.');
		}
	};
	return self;
};
EBContext.async = new EBContext.modules.Async();

EBContext.await = function(reqArr, callback, eventName){
	if(!(reqArr instanceof Array)) reqArr = [reqArr];
	eventName = eventName || null;
	let ok = true;
	let retVal = null;
	for (let m of reqArr) {
		if (EBContext.loadedRequires[m] === undefined) {
			ok=false;
		}
		else {
			retVal = retVal || EBContext.loadedRequires[m];
		}
	}
	if (ok) {
		//all modules already loaded - sync callback
		if(typeof callback === 'function') {
			try{ callback(retVal) } catch(e) { console.error(e) }
		}
		return retVal;
	}
	EBContext.async.start(reqArr, eventName);
	if(typeof callback === 'function'){
		let ca = [];
		
		try{ca = callback.arguments}catch(e){}
		
		let cb = function(ca){
			
			for (let m of reqArr) {
				EBContext.loadedRequires[m] = ca || null;
			}
			try{ callback(ca) } catch(e) { console.error(e) }
			EBContext.async.finish(reqArr, eventName);
		};
		return require(reqArr, cb);
	}
	else{
		EBContext.async.finish(reqArr, eventName);
		return require(reqArr, function(ca) {
			for (let m of reqArr) {
				EBContext.loadedRequires[m] = ca || null;
			}
		});
	}
};

EBContext.modules.Preloader = function(template, styles){
	var self = this;
	this.debug = true;
	this.getScrollbarWidth = function(){
		var outer = document.createElement('div');
		outer.style.visibility = 'hidden';
		outer.style.overflow = 'scroll';
		outer.style.position = 'absolute';
		outer.style.msOverflowStyle = 'scrollbar';
		document.body.appendChild(outer);
		var inner = document.createElement('div');
		outer.appendChild(inner);
		var scrollbarWidth = (outer.offsetWidth - inner.offsetWidth);
		outer.parentNode.removeChild(outer);
		return scrollbarWidth;
	};
	this.construct = function(){
		self.preloadEl = document.createElement('div');
		self.preloadEl.id = 'mwPreloader';
		self.preloadEl.className = 'defaultLoader';
	};
	this.setStyles = function(){
		var styles = 'body.preload{width:100%;overflow:hidden;padding-right:' + self.getScrollbarWidth() + 'px;}';	
		var stylesEl = document.createElement('style');
		stylesEl.type = 'text/css';
		stylesEl.id = 'mwPreloaderStyles';
		stylesEl.innerText = styles;
		document.head.appendChild(stylesEl);
	};
	this.show = function(){
		if(!document.getElementById('mwPreloader')){
			if(!self.preloadEl){
				self.construct();
			} else {
				self.preloadEl.classList.remove('hidden');
			}
			if(document.body.firstChild){
				document.body.insertBefore(self.preloadEl, document.body.firstChild);
			} else {
				document.body.append(self.preloadEl);
			}
		}
		if(!document.getElementById('mwPreloaderStyles')) self.setStyles();
		
		document.body.classList.add('preload');
		document.body.classList.remove('preload-initial');
	};
	this.hide = function(){
		var elem = document.getElementById('mwPreloader');
		if(elem){
			elem.classList.add('hidden'); // zah�j� p�echod opacity 1 > 0 trvaj�c� 0.5s
			setTimeout(function(){ // Po dokon�en� p�echodu lze element odebrat z DOM
				document.body.classList.remove('preload');
				if(elem.parentNode) self.preloadEl = elem.parentNode.removeChild(elem);
			}, 500);
		}
	};
	
	this.checkCSSLoaded = function(){
		var resources = document.querySelectorAll('head>link[href][media="print"]');
		var loading = [];
		var error = [];
		var i;
		var checkTimeout;
		for(i=0;i<resources.length;i++){
			var res = resources[i];
			if(res.sheet) res.setAttribute('loaded', 'loaded');
			var loaded = res.getAttribute('loaded');
			if(!loaded){
				res.setAttribute('loaded', 'loading');
				res.addEventListener('load', function(){
					this.setAttribute('loaded', 'loaded');
				});
				res.addEventListener('error', function(){
					this.setAttribute('loaded', 'error');
				});
				loading.push(res);
			}
			else if(loaded==='loading'){
				loading.push(res);
			}
			else if(loaded!=='loaded'){
				error.push(res);
			}
		}
		if(loading.length===0){
			EBContext.async.finish('asynCSS');
			if(error.length > 0){
				console.groupCollapsed('Error loading ' + loading.length + ' CSS resources!')
				for(i=0;i<error.length;i++){
					console.error(error[i]);
				}
				console.groupEnd();
			}
			else{
				console.info('All async CSS resources were loaded.');
			}
		}
		else{
			checkTimeout = setTimeout(self.checkCSSLoaded, 100);
			if(self.debug){
				console.groupCollapsed('Waiting for ' + loading.length + ' CSS resources!')
				for(i=0;i<loading.length;i++){
					console.log(loading[i]);
				}
				console.groupEnd();
			}
		}
	};
	this.init = function(){
		document.addEventListener("DOMContentLoaded", function(){
			self.show();
			EBContext.async.register(function(){
				self.hide();
			});
			EBContext.async.start('asynCSS');
			self.checkCSSLoaded();
		}, true);
	};
	this.init();
	
	return this;
};
//EBContext.preloader = new EBContext.modules.Preloader();

EBContext.ready = function (callback) {
	EBContext.await('EBContext_AjaxNavigation', ()=>{
		EBContext.ajaxNav.ready(callback);
	});
};

// padding maintainer for .fixed-top and .fixed-bottom
EBContext.utils.paddingMaintainer = function(){
	var ba = ['','-sm','-md','-lg','-xl','-xxl'];
	var pa = ['-top','-bottom'];
	var s = (ss=>{
		var sa=[];
		pa.forEach(pi=>{ba.forEach(bi=>{sa.push('.fixed'+bi+pi)})});
		return sa.join(',');
	})();
	if(document.body){
		document.body.style.paddingTop = '';
		document.body.style.paddingBottom = '';
	}
	let spt = 0;
	let spb = 0;

	document.querySelectorAll(s).forEach(el=>{
		var cs = window.getComputedStyle(el);
		if(cs.position === 'fixed' && cs.top === '0px'){
			let elh = parseFloat(cs.height.replace('px', ''));
			if(elh > spt) spt = elh;
		}
		else if(cs.position === 'fixed' && cs.bottom === '0px'){
			let elh = parseFloat(cs.height.replace('px', ''));
			if( elh > spb) spb = elh;
		}
	});
	var htmlStyle = document.head.querySelector('style#htmlStyle');
	if(!htmlStyle){
		htmlStyle = document.createElement('style');
		htmlStyle.id = 'htmlStyle';
		document.head.appendChild(htmlStyle);
	}
	let root = document.documentElement;
	root.style.setProperty('--scroll-padding-top', spt+'px');
	root.style.setProperty('--scroll-padding-bottom', spb+'px');
	htmlStyle.innerText = 'html{scroll-padding-top: calc(' + spt + 'px + 2.5rem); scroll-padding-bottom: calc' + spb + 'px + 2.5rem)} body{padding-top: ' + spt + 'px; padding-bottom: ' + spb + 'px}';
};
window.addEventListener('resize', EBContext.utils.paddingMaintainer);
EBContext.ready(EBContext.utils.paddingMaintainer);